var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[(_vm.alertValue)?_c('AlertMessages',{attrs:{"alert-type":_vm.alertType,"alert-msg":_vm.alertMsg},on:{"reset":function($event){_vm.alertValue = false}}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyPolicy)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }